import { sortAlphabetically } from '../../../data/lib/sort';
import { DEFAULT_LOCALE } from 'shared/i18n';

export function addDistanceToFacilities(coordinates, user, facilities, locale) {
  let latLong = {};

  if (coordinates && coordinates.latitude && coordinates.longitude) {
    latLong = coordinates;
  } else if (user && user.latitude && user.longitude) {
    latLong = user;
  }
  if (latLong.latitude && latLong.longitude) {
    return facilities.map((eachFacility, idx) => {
      const rawDistance = calculateDistance(eachFacility, latLong.latitude, latLong.longitude);
      const distance = locale === DEFAULT_LOCALE || !locale ? rawDistance : rawDistance * 1.609;

      return {
        ...eachFacility,
        distance,
        idx,
      };
    });
  }
  return facilities;
}

// haversine formula to calculate great-circle distance between two points
function calculateDistance(facility, userLat, userLong) {
  if (facility.address && facility.address.latitude && facility.address.longitude) {
    /* eslint-disable id-length */
    const lat1 = userLat;
    const lat2 = facility.address.latitude;
    const lon1 = userLong;
    const lon2 = facility.address.longitude;
    const toRadians = x => (x * Math.PI) / 180;
    const R = 3959; // miles
    const p1 = toRadians(+lat1);
    const p2 = toRadians(+lat2);
    const dp = toRadians((+lat2 - +lat1));
    const dl = toRadians((+lon2 - +lon1));
    const a = (Math.sin(dp / 2) * Math.sin(dp / 2)) +
      ((Math.cos(p1) * Math.cos(p2)) *
      (Math.sin(dl / 2) * Math.sin(dl / 2)));
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d.toFixed(0);
    /* eslint-enable id-length */
  }
  return 0;
}

export function sortFacilities(facilities) {
  const comparator = (x, y) => {
    // sort by distance first
    if (x.distance && y.distance) {
      if (+x.distance > +y.distance) return 1;
      if (+x.distance < +y.distance) return -1;
      return sortAlphabetically(x.displayName, y.displayName);
    }
    // put any facility with distance ahead of those without
    if (x.distance && !y.distance) return -1;
    if (!x.distance && y.distance) return 1;
    // if neither have distance, sort alphabetically
    return sortAlphabetically(x.displayName, y.displayName);
  };
  return facilities.sort(comparator);
}

export function getSortedFacilities(coordinates, user, facilities, number) {
  if (!facilities) return [];
  const facilitiesWithDist = addDistanceToFacilities(coordinates, user, facilities);
  let sortedFacilities = sortFacilities(facilitiesWithDist.filter(Boolean));
  if (number) sortedFacilities = sortedFacilities.slice(0, number);
  return sortedFacilities;
}
